import {createReducer} from '../../base/fsa/createReducer';
import {setTemperatureAction} from './action';
import {initialTemperatureState} from './state';

export const temperatureReducer = createReducer(
    initialTemperatureState,
    handle => [
        handle(setTemperatureAction, (state, action) => {
            return {
                ...state,
                icon: action.payload.icon,
                temperature: action.payload.temperature,
            };
        }),
    ],
);
